import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import UserService from "apiService/permissions";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useDeleteGroupPermission = (onClose) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.DELETE_GROUP_PERMISSION],
    (id) => UserService.deleteGroupPermission(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_PERMISSION_GROUP);
        onClose()
        toast.success('Group permission deleted successfully')
      },
      onError: (error) => {
        toast.error(error.response.data.message)
    },
    }
  );
};

export default useDeleteGroupPermission